import { useAuthStore } from '../stores/authStore';

export const useAuth = () => {
  const store = useAuthStore();

  return {
    user: store.user,
    profile: store.user, // Alias for compatibility
    session: store.session,
    isLoading: store.isLoading,
    isInitialized: store.isInitialized,
    isPasswordRecoveryMode: store.isPasswordRecoveryMode,  
    isAuthenticated: !!store.user && !!store.session && !store.isPasswordRecoveryMode,  
    error: store.error,
    signIn: store.signIn,
    signOut: store.signOut,
    refreshUser: store.refreshUser,
    setError: store.setError,
    clearError: store.clearError,
    clearPasswordRecoveryMode: store.clearPasswordRecoveryMode, 
    initialize: store.initialize,
    syncAuthState: store.syncAuthState,
  };
};